export function mergeMaster(data) {
    return new Promise((resolve, reject) => {
		let { mergeMasterRequest, mergeMasterError, mergeMasterResult } = this.props;

		this.doAction(
			this.WEB_REQUEST_URL + 'merge_master',
			this.createBundle(
				'merge_master',
				{ data: data },
				this.POST,
				mergeMasterRequest,
                (result) => {
                    mergeMasterResult(result)
                    resolve(result)
                },
                (error) => {
                    mergeMasterError(error)
                    reject(error)
                }
			)
		);
	})
}
